import { render, staticRenderFns } from "./MisPruebas.vue?vue&type=template&id=e5ba4192&"
import script from "./MisPruebas.vue?vue&type=script&lang=js&"
export * from "./MisPruebas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports